import { c as _c } from "react/compiler-runtime";
import { Field, FieldError, FieldLabel, Input, InputGroup, InputGroupAddon, InputGroupInput, Spinner } from '@repo/ui/components';
import { ComponentProps } from 'react';
import { useFieldContext } from '../../lib/form-context.ts';
import { ReadOnlyField, useReadOnly } from '../../components/readonly.tsx';
export const FormTextInput = t0 => {
  const $ = _c(41);
  let label;
  let props;
  let readOnly;
  let t1;
  let t2;
  let t3;
  let tooltipContent;
  if ($[0] !== t0) {
    ({
      disabled: t1,
      isPending: t2,
      label,
      placeholder: t3,
      readOnly,
      tooltipContent,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = label;
    $[2] = props;
    $[3] = readOnly;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = tooltipContent;
  } else {
    label = $[1];
    props = $[2];
    readOnly = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    tooltipContent = $[7];
  }
  const disabled = t1 === undefined ? false : t1;
  const isPending = t2 === undefined ? false : t2;
  const placeholder = t3 === undefined ? "-" : t3;
  const field = useFieldContext();
  let t4;
  if ($[8] !== field.state.meta.errors) {
    t4 = field.state.meta.errors ?? [];
    $[8] = field.state.meta.errors;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const errors = t4;
  const isReadOnly = useReadOnly(readOnly);
  if (isReadOnly) {
    let t5;
    if ($[10] !== label) {
      t5 = label && <FieldLabel>{label}</FieldLabel>;
      $[10] = label;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    const t6 = field.state.value || "-";
    let t7;
    if ($[12] !== t5 || $[13] !== t6 || $[14] !== tooltipContent) {
      t7 = <ReadOnlyField label={t5} tooltipContent={tooltipContent}>{t6}</ReadOnlyField>;
      $[12] = t5;
      $[13] = t6;
      $[14] = tooltipContent;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    return t7;
  }
  let t5;
  if ($[16] !== field.name || $[17] !== label) {
    t5 = label ? <FieldLabel htmlFor={field.name}>{label}</FieldLabel> : null;
    $[16] = field.name;
    $[17] = label;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  const t6 = isPending || disabled;
  let t7;
  if ($[19] !== field) {
    t7 = e => field.handleChange(e.target.value);
    $[19] = field;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== field.handleBlur || $[22] !== field.name || $[23] !== field.state.value || $[24] !== placeholder || $[25] !== props || $[26] !== t6 || $[27] !== t7) {
    t8 = <InputGroupInput className="placeholder:text-foreground focus:placeholder:text-muted-foreground h-6 p-0 !text-base focus:px-3" data-testid="form-text-input" disabled={t6} id={field.name} onBlur={field.handleBlur} onChange={t7} placeholder={placeholder} value={field.state.value} {...props} data-sentry-element="InputGroupInput" data-sentry-source-file="form-text-input.tsx" />;
    $[21] = field.handleBlur;
    $[22] = field.name;
    $[23] = field.state.value;
    $[24] = placeholder;
    $[25] = props;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== isPending) {
    t9 = isPending && <InputGroupAddon align="inline-end"><Spinner className="text-muted-foreground" /></InputGroupAddon>;
    $[29] = isPending;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== props.variant || $[32] !== t8 || $[33] !== t9) {
    t10 = <InputGroup variant={props.variant} data-sentry-element="InputGroup" data-sentry-source-file="form-text-input.tsx">{t8}{t9}</InputGroup>;
    $[31] = props.variant;
    $[32] = t8;
    $[33] = t9;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  let t11;
  if ($[35] !== errors) {
    t11 = <FieldError className="text-sm" errors={errors} data-sentry-element="FieldError" data-sentry-source-file="form-text-input.tsx" />;
    $[35] = errors;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== t10 || $[38] !== t11 || $[39] !== t5) {
    t12 = <Field className="gap-1" data-sentry-element="Field" data-sentry-component="FormTextInput" data-sentry-source-file="form-text-input.tsx">{t5}{t10}{t11}</Field>;
    $[37] = t10;
    $[38] = t11;
    $[39] = t5;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  return t12;
};